var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app},[_c('EndScreen',_vm._b({attrs:{"stars":3,"noRetry":"","inline":""},on:{"end":function($event){return _vm.$emit('finish')}}},'EndScreen',_vm.$attrs.end,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }